export default {
  install(Vue) {
    const $cookies = Vue.prototype.$cookies;
    Vue.prototype.cookiePut = function(key, value, expires, path, domain, secure) {
      $cookies.set(key, value, expires, path, domain, secure);
    }
    Vue.prototype.cookieGet = function(key) {
      return $cookies.get(key);
    }
    Vue.prototype.cookieGetAll = function() {
      let keys = $cookies.keys();
      let cookies = [];
      for (let key of keys) {
        cookies.push({ [key]: $cookies.get(key) });
      }
      return cookies;
    }
    Vue.prototype.cookieRemove = function(key, path, domain) {
      $cookies.remove(key, path, domain);
    }
    Vue.prototype.cookieRemoveAll = function() {
      let keys = $cookies.keys();
      for (let key of keys) {
        $cookies.remove(key);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/service/cookie-service.js